import PromiseCancelError from './promiseCancelError';

export default class ReconectPromiseCancelError extends PromiseCancelError {
    constructor(message = 'ReconectPromiseCancelError', ...args) {
        super(...args);
        this.message = message;
        this.code = 'reconnect promise is canceled';
    }
}
